module.exports = __webpack_public_path__ + "7d0bd25801d75a5692924edfd10776a4.MP3";